
const {REACT_APP_DEPLOY_TARGET, NODE_ENV: env, REACT_APP_ZORKO_RECAPTCHA_SITE_KEY} = process.env; // eslint-disable-line

class Config {
  constructor(env) {
    if (REACT_APP_DEPLOY_TARGET === 'staging') {
      this.env = 'staging';
    } else {
      this.env = env;
    }
  }

  get gitLoginClientId() {
    switch (this.env) {
      case 'development':
        return '1ef6c1d9f746169c72a7';
      default:
        return 'not setup yet';
    }
  }

  get reCapptchaSiteKey() {
    return REACT_APP_ZORKO_RECAPTCHA_SITE_KEY;
  }
  get apiUrl() {
    switch (this.env) {
      case 'development':
        return 'http://localhost:3001';
      case 'staging':
        return 'https://coin-reg-test.herokuapp.com';
      default:
        return 'http://prod.url';
    }
  }

}

export default new Config(env);



// WEBPACK FOOTER //
// ./src/config/index.js